"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxVolume = void 0;
exports.getFadeInY = getFadeInY;
exports.createFadeIn = createFadeIn;
var Utilities_1 = require("./Utilities");
exports.maxVolume = 0.3;
function getFadeInY(a) {
    return Math.min(-Math.log(-a + 1), exports.maxVolume);
}
function createFadeIn(durationMs, yFunc) {
    var startTime = performance.now();
    var running = true;
    var tickFunc = function () {
        var now = performance.now();
        var elapsed = now - startTime;
        if (elapsed > durationMs || !running) {
            yFunc(exports.maxVolume, true);
            return;
        }
        var y = getFadeInY(elapsed / durationMs);
        yFunc(y);
        (0, Utilities_1.rafTimeout)(tickFunc);
    };
    (0, Utilities_1.rafTimeout)(tickFunc);
    yFunc(0.0);
    return {
        dispose: function () {
            running = false;
        },
    };
}
//# sourceMappingURL=Curves.js.map